import styled from 'styled-components';

export const Title = styled.h2`
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  line-height: 32px;
  margin-bottom: 1rem;

  &.first {
    font-size: 36px;
  }
`;

export const Body = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 27px;
`;

export const CarouselWrapper = styled.div`
  .slick-track {
    padding-top: 20px;
  }
`;
